import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import App from "./App";
import "./App.css";
import AuthContextProvider from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import NotificationProvider from "./context/NotificationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <AuthContextProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </AuthContextProvider>
    </LanguageProvider>
  </React.StrictMode>
);
